import axios from 'axios'
import { CART_ADD_ITEM, CART_REMOVE_ITEM, CART_SAVE_PAYMENT_METHOD, CART_SAVE_PRICES, CART_SAVE_SHIPPING_ADDRESS } from '../constants/cartConstants';
import {url} from '../prod'



export const addToCart = (productId, qty) => async (dispatch, getState) => {
    const { data } = await axios.get(`${url}api/products/${productId}`)
    dispatch({
        // requesting the redux store this data to cart 
        type: CART_ADD_ITEM,
        payload: {
            
            name: data.name,
            image: data.image,
            price: data.price,
            countInStock: data.countInStock,
            product: data._id,
            qty,
        }

    })
    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
}

export const removeFromCart = (productId) => (dispatch, getState) => {
    dispatch({ type: CART_REMOVE_ITEM, payload: productId });
    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
};

export const saveShippingAddress = (data) => async (dispatch, getState) => {
    dispatch({ type: CART_SAVE_SHIPPING_ADDRESS, payload: {data} })
    localStorage.setItem('shipping-address', JSON.stringify(data));
}

export const savePrices = (prices) => async (dispatch, getState) => {
    dispatch({ type: CART_SAVE_PRICES, payload: prices })
}


export const savePaymentMethod = (paymentMethod) => async (dispatch, getState) => {
    dispatch({ type: CART_SAVE_PAYMENT_METHOD, payload: paymentMethod })
    localStorage.setItem('paymentMethod', JSON.stringify(paymentMethod));
}